
import React from 'react';

import { Button } from '../input/Button.jsx';
import { Input } from '../input/Text.jsx';

class Checkbox extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.props.onClick) {
            this.props.onClick(this.props.name, this.props.d);
        }
    }

    render() {
        const data = this.props.d || {};
        const inputProps = {
            className: this.props.className,
            id: data.value,
            type: 'checkbox'
        }
        let className = 'check__item';
        if (this.props.fullWidth) {
            className += ' check__item--fullwidth';
        }
        return (
            <span className={className} onClick={this.handleClick}>
                {
                    this.props.checked &&
                    <input {...inputProps} defaultChecked={true} />
                }
                {
                    !this.props.checked &&
                    <input {...inputProps} />
                }
                <label className="check__name" htmlFor={data.value}>{data.display}</label>
                {this.props.children}
            </span>
        );
    }
}

class ColorButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onClick) {
            this.props.onClick('color', this.props.d);
        }
    }

    render() {
        let className = 'color__circle';
        if (this.props.active) {
            className += ' color__circle--active';
        }
        const style = { backgroundColor: this.props.d.display };
        if (this.props.d.style) {
            for (let id in this.props.d.style) {
                style[id] = this.props.d.style[id];
            }
        }
        if (style.border && this.props.active) {
            style.borderColor = 'grey';
        }
        return (
            <span className={className} style={style} onClick={this.handleClick} />
        );
    }
}

class Container extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.colors = [
            { display: 'Red', value: '#d10000' },
            { display: 'Orange', value: '#ff6622' },
            { display: 'Yellow', value: '#ffda21' },
            { display: 'Green', value: '#33dd00' },
            { display: 'Blue', value: '#1133cc' },
            { display: 'Purple', value: '#220066' },
            { display: 'Black', value: '#000000' },
            { display: 'White', value: '#ffffff', style: { border: '.3rem solid black' } }
        ];
        this.mediums = [
            { display: 'Oil', value: 'Oil' },
            { display: 'Acrylic', value: 'Acrylic' },
            { display: 'Mixed Media', value: 'Mixed Media' },
            { display: 'Photography', value: 'Photography' },
            { display: 'Sculpture', value: 'Sculpture' },
            { display: 'Paper', value: 'Paper' }
        ];
        this.periods = [
            { display: '2010s', value: '1' },
            { display: '2000s', value: '2' },
            { display: '1990s', value: '3' },
            { display: '1980s', value: '4' },
            { display: '1970s', value: '5' },
            { display: '1960s', value: '6' },
            { display: '1950s', value: '7', props: { fullWidth: true } },
            { display: 'early 20th century', value: '8', props: { fullWidth: true } }
        ];
        this.locations = [
            { display: 'Atlanta', value: '10' },
            { display: 'New York', value: '32' },
            { display: 'San Francisco', value: '31' },
            { display: 'Dallas', value: '38' },
            { display: 'Santa Fe', value: '6' },
            { display: 'Los Angeles', value: '39' },
            { display: 'Miami', value: '30' }
        ];

        this.heightMax = 60;
        this.priceMax = 20000;
        this.widthMax = 60;

        this._handleSearchInputRef = this._handleSearchInputRef.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleHeightChange = this.handleHeightChange.bind(this);
        this.handleHeightReset = this.handleHeightReset.bind(this);
        this.handlePriceChange = this.handlePriceChange.bind(this);
        this.handlePriceReset = this.handlePriceReset.bind(this);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleWidthChange = this.handleWidthChange.bind(this);
        this.handleWidthReset = this.handleWidthReset.bind(this);
    }

    componentDidMount() {
        gio.browse.initsliders(
            { callback: this.handlePriceChange, from: 0, to: this.priceMax },
            { callback: this.handleWidthChange, from: 0, to: this.widthMax },
            { callback: this.handleHeightChange, from: 0, to: this.heightMax }
        );
        if (this.props.renderOptions && this.props.renderOptions.labels) {
            this.getLabels();
        }
    }

    componentWillUnmount() {
        if (this.labelsRequest) {
            this.labelsRequest.abort();
            this.labelsRequest = null;
        }
    }

    _handleSearchInputRef(ref) {
        this.searchInputRef = ref;
    }

    getLabels() {
        const component = this;
        component.labelsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.art.labels.get(),
            null,
            function (responseData) {
                component.labelsRequest = null;

                const labels = [];
                let d;
                for (let i = 0; i < responseData.Labels.length; i++) {
                    if (i > 100) {
                        break;
                    }
                    d = responseData.Labels[i];
                    d.display = d.Label;
                    d.value = d.Label;
                    labels.push(d);
                }
                component.setState({
                    labels: labels
                });
            },
            function () {
                component.labelsRequest = null;
            }
        );
    }

    handleChange(name, data) {
        if (!this.props.onChange) {
            return;
        }
        const filters = this.props.filters || {};
        let _data;
        if (!filters[name] || filters[name].value != data.value) {
            _data = data;
        }
        this.props.onChange(name, _data);
    }

    handleHeightChange(data) {
        if (!this.props.onChange) {
            return;
        }
        const filters = this.props.filters || {};
        let maxHeight;
        if (data.to < this.heightMax) {
            maxHeight = data.to;
        }
        if (filters.maxHeight != maxHeight) {
            this.props.onChange('maxHeight', maxHeight);
        }
        let minHeight;
        if (data.from > 0) {
            minHeight = data.from;
        }
        if (filters.minHeight != minHeight) {
            this.props.onChange('minHeight', minHeight);
        }
    }

    handleHeightReset(minHeight, maxHeight) {
        const from = minHeight || 0;
        const to = maxHeight || this.heightMax;
        $('.slider--height').data('ionRangeSlider').update({ from: from, to: to });
    }

    handlePriceChange(data) {
        if (!this.props.onChange) {
            return;
        }

        const filters = this.props.filters || {};
        let maxPrice;
        if (gio.browse._pricevalues[data.to] < this.priceMax) {
            maxPrice = gio.browse._pricevalues[data.to];
        }
        if (filters.maxPrice != maxPrice) {
            this.props.onChange('maxPrice', maxPrice);
        }
        let minPrice;
        if (gio.browse._pricevalues[data.from] > 0) {
            minPrice = gio.browse._pricevalues[data.from];
        }
        if (filters.minPrice != minPrice) {
            this.props.onChange('minPrice', minPrice);
        }
    }

    handlePriceReset(minPrice, maxPrice) {
        const range = $('.slider--price').data('ionRangeSlider');
        const values = range.options.values;
        const from = minPrice || 0;
        const to = maxPrice || this.priceMax;
        range.update({ from: values.indexOf(from), to: values.indexOf(to) });
    }

    handleSearchSubmit(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onChange) {
            let search = this.props.search;
            if (!search || !search.length) {
                search = undefined;
            }
            if (this.props.filters && search != this.props.filters.q) {
                this.props.onChange('q', search);
            }
        }
        if (this.searchInputRef) {
            this.searchInputRef.blur();
        }
    }

    handleSort(value) {
        if (!this.props.onChange) {
            return;
        }
        const filters = this.props.filters || {};
        const order = parseInt(value, 10);
        if (isNaN(order) || filters.order == order) {
            return;
        }
        if (this.props.onChange) {
            this.props.onChange('order', order);
        }
    }

    handleWidthChange(data) {
        if (!this.props.onChange) {
            return;
        }
        const filters = this.props.filters || {};
        let maxWidth;
        if (data.to < this.widthMax) {
            maxWidth = data.to;
        }
        if (filters.maxWidth != maxWidth) {
            this.props.onChange('maxWidth', maxWidth);
        }
        let minWidth;
        if (data.from > 0) {
            minWidth = data.from;
        }
        if (filters.minWidth != minWidth) {
            this.props.onChange('minWidth', minWidth);
        }
    }

    handleWidthReset(minWidth, maxWidth) {
        const from = minWidth || 0;
        const to = maxWidth || this.widthMax;
        $('.slider--width').data('ionRangeSlider').update({ from: from, to: to });
    }

    render() {
        const component = this;
        const filters = component.props.filters || {};
        const widgetClassName = this.props.widgetClassName || '';
        const activeLabels = {};
        if (filters.label) {
            filters.label.forEach(function (d) {
                activeLabels[d.value] = true;
            });
        }
        const activeLocations = {};
        if (filters.location) {
            filters.location.forEach(function (d) {
                activeLocations[d.value] = true;
            });
        }
        const activePeriods = {};
        if (filters.period) {
            filters.period.forEach(function (d) {
                activePeriods[d.value] = true;
            });
        }
        const renderOptions = component.props.renderOptions || {};
        return (
            <React.Fragment>
                {
                    this.props.sortOptions &&
                    this.props.sortOptions.length > 0 &&
                    <Widget title={this.props.renderFirstWidgetTitle ? 'Sort By' : undefined} className={`sidebar__widget--tight ${widgetClassName}`}>
                        <div className="sort__container">
                            {this.props.sortOptions.map((d) => <Button key={d.value} config={{ selected: (filters.order == d.value ? 'sort--selected' : undefined), size: 'small', style: 'sort' }} name={d.value} onClick={this.handleSort}>{d.display}</Button>)}
                        </div>
                    </Widget>
                }
                
                {
                    renderOptions.search &&
                    <Widget className={widgetClassName}>
                        <form onSubmit={this.handleSearchSubmit}>
                            <div className="input__container input--grey input--medium input--ir">
                                <Input
                                    name="search"
                                    placeholder="Search..."
                                    type="text"
                                    value={this.props.search}
                                    onChange={this.props.onChange}
                                    onRef={this._handleSearchInputRef} />
                                <button className="i i--search" type="submit" />
                            </div>
                        </form>
                    </Widget>
                }
                {
                    renderOptions.price &&
                    <Widget title="Price" className={widgetClassName}>
                        <div className="range-slider">
                            <input className="slider--price" />
                        </div>
                    </Widget>
                }
                {
                    renderOptions.colors &&
                    <Widget className={widgetClassName}>
                        <div className="color__container">
                            {this.colors.map((d) => <ColorButton key={d.display} active={filters.color && filters.color.value == d.value} d={d} onClick={this.handleChange} />)}
                        </div>
                    </Widget>
                }
                {
                    renderOptions.mediums &&
                    <Widget title="Medium" className={widgetClassName}>
                        <div className="widget__categories">
                            {this.mediums.map((d) => <MediumButton key={d.value} href="#" className={filters.medium && filters.medium.value == d.value ? 'selected' : undefined} d={d} onClick={this.handleChange} />)}
                        </div>
                    </Widget>
                }
                {
                    renderOptions.height &&
                    <Widget title="Height" className={widgetClassName}>
                        <div className="range-slider">
                            <input className="slider--height" />
                        </div>
                    </Widget>
                }
                {
                    renderOptions.width &&
                    <Widget title="Width" className={widgetClassName}>
                        <div className="range-slider">
                            <input className="slider--width" />
                        </div>
                    </Widget>
                }
                {
                    renderOptions.locations &&
                    <Widget title="Location" className={widgetClassName}>
                        <div className="check__container check--fullwidth">
                            {this.locations.map((d) => <Checkbox key={d.value} checked={activeLocations[d.value] == true} d={d} name="location" onClick={this.props.onChange} />)}
                        </div>
                    </Widget>
                }
                {
                    false &&
                    // renderOptions.periods &&
                    <Widget title="Periods" className={widgetClassName}>
                        <div className="check__container check--double">
                            {
                                component.periods.map(function (d) {
                                    const props = d.props || {};
                                    return (
                                        <Checkbox
                                            key={d.value}
                                            checked={activePeriods[d.value] == true}
                                            d={d}
                                            name="period"
                                            onClick={component.props.onChange}
                                            {...props} />
                                    );
                                })
                            }
                        </div>
                    </Widget>
                }
                {
                    renderOptions.labels &&
                    <Widget title="Labels" className={widgetClassName}>
                        <div className="check__container check--fullwidth">
                            {
                                this.state.labels &&
                                this.state.labels.map((d) => <Checkbox key={d.value} checked={activeLabels[d.value] == true} d={d} fullWidth={true} name="label" onClick={this.props.onChange}><span className="check__number">{d.Count}</span></Checkbox>)
                            }
                        </div>
                    </Widget>
                }
            </React.Fragment>
        );
    }
}

class MediumButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onClick) {
            this.props.onClick('medium', this.props.d);
        }
    }

    render() {
        return (
            <a href="#" className={this.props.className} onClick={this.handleClick}>{this.props.d.display}</a>
        );
    }
}

function Widget(props) {
    return (
        <div className={`sidebar__widget ${props.className ? props.className : ''}`}>
            {
                props.title &&
                props.title.length > 0 &&
                <h6 className="sidebar__widget__title">{props.title}</h6>
            }
            {props.children}
        </div>
    );
}

export default Container;